import type { User, StudentUserData, Center } from '../types';
import { Level } from '../enums';

import {
  defaultHelpDelaySecs, defaultShowRepeatButtonDelaySecs,
  sessionsBeforeLevelChange
} from '../constants';

class LoggedIn {
  value = $state<boolean>(false);
}

class UserEmail {
  value = $state<string>("");
}

class UserStore {
  value = $state<User>({
    name: "",
    uid: "",
    role: "",
    centerUid: "",
    active: false
  });
}

class StudentUserDataStore {
  value = $state<StudentUserData>({
    sessionsCompleted: 0,
    currentLevel: Level.First,
    completedOnCurrentLevel: 0,
    settings: {
      helpDelaySecs: defaultHelpDelaySecs,
      repeatDelaySecs: defaultShowRepeatButtonDelaySecs,
      perseveration: false,
      doTestNextSession: false,
      doIntroNextSession: false,
      sessionsBeforeLevelChange: sessionsBeforeLevelChange,
      qwertyKeyboard: false,
      simpleSpelling: false
    }
  });
}

class CenterStore {
  value = $state<Center>({
    name: "",
    uid: "",
    maxActiveUsers: 0
  });
}

class PwaNameForResults {
  value = $state<string>("");
}

class PwaEmailForResults {
  value = $state<string>("");
}

export const loggedIn = new LoggedIn();
export const userEmail = new UserEmail();
export const user = new UserStore();
export const studentUserData = new StudentUserDataStore();
export const center = new CenterStore();
export const pwaNameForResults = new PwaNameForResults();
export const pwaEmailForResults = new PwaEmailForResults();
